import { render } from "./TestPersonality.vue?vue&type=template&id=1381eb17&scoped=true"
import script from "./TestPersonality.vue?vue&type=script&lang=js"
export * from "./TestPersonality.vue?vue&type=script&lang=js"

import "./TestPersonality.vue?vue&type=style&index=0&id=1381eb17&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1381eb17"]])

export default __exports__